<app-modal-base [title]="dialogTitle" hasSubmit="false" cancelType="CLOSE">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <div class="chart">
      <ng-container *ngIf="!loading; else loadingSpinner">
        <google-chart
          *ngIf="hasData; else noData"
          class="noverflow w-100"
          #chart
          [type]="chartType"
          [dynamicResize]="true"
          [data]="chartData"
          [columns]="columnNames"
          [options]="options"
        ></google-chart>
      </ng-container>
    </div></div
></ng-template>

<ng-template #noData>
  Aucune donnée historique disponible pour ce KPI
</ng-template>

<ng-template #loadingSpinner>
  <mat-icon>
    <mat-spinner diameter="20"> </mat-spinner>
  </mat-icon>
</ng-template>
